import React from 'react';
import { Box } from '@mui/material';

import hisImg from '../../data/images/history.png';
import hisImg_mobile from '../../data/images/history_mobile.png';

type Props = {}



const HistoryPage = (props: Props) => {

    const webWidth = window.innerWidth;
    
    return (
        <>
            <Box 
                sx={{ 
                width: '100%', 
                height: 'auto', 
                // border: '1px solid black',
                // backgroundColor: 'black',
                p: 0,
                mt: '8em',
                mb: '3em'
                }}>
                {
                    webWidth > 1300
                    ?
                    <img src={hisImg} width={'100%'} />
                    :
                    <img src={hisImg_mobile} width={'100%'} />
                }
            </Box>
        </>
    )
}

export default HistoryPage